import React from "react";
import img1 from '../assets/images/f-delivery.png';
import img2 from '../assets/images/coin.png';
import img3 from '../assets/images/chat.png';

const FeaturesSection = () => {
  return (
    <section className="features-section py-5">
      <div className="container">
        <div className="row text-center justify-content-center">
          
          <div className="col-md-4 mb-4">
            <div className="feature-item">
              <img src={img1} alt="Free shipping" className="feature-img mb-3" />
              <h5 className="fw-bold">Free Shipping</h5>
              <p className="feature-text">
                Enjoy fast and free delivery on all orders with no minimum purchase required.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="feature-item">
              <img src={img2} alt="Money back" className="feature-img mb-3" />
              <h5 className="fw-bold">100% Money Back</h5>
              <p className="feature-text">
                Shop confidently with our hassle-free return and full money-back guarantee.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="feature-item">
              <img src={img3} alt="Online support" className="feature-img mb-3" />
              <h5 className="fw-bold">Online Support 24/7</h5>
              <p className="feature-text">
                Our support team is available around the clock to help you anytime you need.
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
